export default {
	create (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'notification/create', params)
	},
	receive_all (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'notification/receive_all', params)
	},
	receive_mine (params = new URLSearchParams()) {
		return Axios.post(API_BASE + 'notification/receive_mine', params)
	}
}



// WEBPACK FOOTER //
// ./src/api/Notification.js